module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-span-12"
  }, [_c('div', {
    staticClass: "px-5 sm:px-8 py-5 sm:py-10"
  }, [(_vm.activity.type == 'Parejas') ? _c('div', {
    staticClass: "border-red-600 border-2 p-4 text-red-600 rounded"
  }, [_vm._v("\n      Recuerda que el numero de preguntas para la actividad de "), _c('b', [_vm._v("Parejas")]), _vm._v(" debe ser multiplos de 4.\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.checked && !_vm.isShow) ? _c('form', {
    staticClass: "intro-y grid grid-cols-12 gap-3 py-0",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addQuestionToActivity()
      }
    }
  }, [_c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-4"
  }, [_c('label', [_vm._v("Agregar pregunta:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentActivityQuestion.title),
      expression: "currentActivityQuestion.title"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.currentActivityQuestion.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentActivityQuestion, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-4"
  }, [_c('label', [_vm._v("Tiempo para respoder (en segundos):")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentActivityQuestion.time_in_seconds),
      expression: "currentActivityQuestion.time_in_seconds"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.currentActivityQuestion.time_in_seconds)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentActivityQuestion, "time_in_seconds", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "overflow-x-auto"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), (!_vm.activityQuestions.length) ? _c('tbody', [_vm._m(2)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.activityQuestions), function(item, questionIndex) {
    return _c('tbody', {
      key: ((item.title) + "-question-item-" + questionIndex),
      staticClass: "border-b dark:border-dark-5"
    }, [_c('tr', {
      staticClass: "border"
    }, [_c('td', {
      staticClass: "whitespace-nowrap text-center cursor-pointer",
      class: _vm.showCurrentQuestion == questionIndex ? 'text-indigo-600 mobile-menu' : '',
      on: {
        "click": function($event) {
          _vm.showCurrentQuestion = questionIndex
        }
      }
    }, [_vm._v("\n              No. " + _vm._s(questionIndex + 1) + "\n            ")]), _vm._v(" "), _c('td', [(!_vm.checked) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.lazy",
        value: (item.title),
        expression: "item.title",
        modifiers: {
          "lazy": true
        }
      }],
      staticClass: "input w-full border mt-2",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "change": function($event) {
          return _vm.$set(item, "title", $event.target.value)
        }
      }
    }) : _c('div', {
      staticClass: "font-medium whitespace-nowrap"
    }, [_vm._v("\n                " + _vm._s(item.title) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "whitespace-nowrap text-center"
    }, [(!_vm.checked) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.lazy",
        value: (item.time_in_seconds),
        expression: "item.time_in_seconds",
        modifiers: {
          "lazy": true
        }
      }],
      staticClass: "input w-full border mt-2",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (item.time_in_seconds)
      },
      on: {
        "change": function($event) {
          return _vm.$set(item, "time_in_seconds", $event.target.value)
        }
      }
    }) : _c('div', {
      staticClass: "font-medium whitespace-nowrap"
    }, [_vm._v("\n                " + _vm._s(item.time_in_seconds) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-right",
      attrs: {
        "rowspan": "1"
      }
    }, [(!_vm.checked && !_vm.isShow) ? _c('button', {
      staticClass: "button bg-theme-6 text-white mt-auto",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.activityQuestions.splice(questionIndex, 1)
        }
      }
    }, [_vm._v("\n                Eliminar Pregunta\n              ")]) : _vm._e()])]), _vm._v(" "), _c('tr', {
      staticClass: "border mb-3"
    }, [_c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showCurrentQuestion == questionIndex),
        expression: "showCurrentQuestion == questionIndex"
      }],
      attrs: {
        "colspan": "4"
      }
    }, [_c('div', {
      staticClass: "flex flex-col"
    }, [_c('h5', {
      staticClass: "mx-auto"
    }, [_vm._v("RESPUESTAS:")]), _vm._v(" "), _c('div', [_c('table', {
      staticClass: "w-full"
    }, [(item.answers.length) ? _c('thead', [_vm._m(3, true)]) : _vm._e(), _vm._v(" "), _c('tbody', {
      staticClass: "border-b"
    }, _vm._l((item.answers), function(answer, index) {
      return _c('tr', {
        key: ("answers-key-" + index)
      }, [_c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model.lazy",
          value: (answer.text_answer),
          expression: "answer.text_answer",
          modifiers: {
            "lazy": true
          }
        }],
        staticClass: "input w-full border mt-2",
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (answer.text_answer)
        },
        on: {
          "change": function($event) {
            return _vm.$set(answer, "text_answer", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', {
        staticClass: "flex"
      }, [_c('div', {
        staticClass: "mx-auto"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model.lazy",
          value: (answer.correct),
          expression: "answer.correct",
          modifiers: {
            "lazy": true
          }
        }],
        staticClass: "checkbox mt-2 border",
        attrs: {
          "type": "checkbox",
          "name": questionIndex,
          "disabled": answer.correct
        },
        domProps: {
          "checked": Array.isArray(answer.correct) ? _vm._i(answer.correct, null) > -1 : (answer.correct)
        },
        on: {
          "change": [function($event) {
            var $$a = answer.correct,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(answer, "correct", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(answer, "correct", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(answer, "correct", $$c)
            }
          }, function($event) {
            return _vm.checkWhichAnswerChanged(questionIndex, index)
          }]
        }
      }), _vm._v("\n                            " + _vm._s(answer.correct ? 'Si' : 'No') + "\n                          ")])]), _vm._v(" "), _c('td', [(!_vm.isShow) ? _c('div', {
        staticClass: "flex"
      }, [_c('button', {
        staticClass: "button bg-theme-6 text-white mx-auto",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return item.answers.splice(index, 1)
          }
        }
      }, [_vm._v("\n                              Eliminar Respuesta\n                            ")])]) : _vm._e()])])
    }), 0), _vm._v(" "), (item.answers.length < 4 && _vm.activity.type == 'Trivia' || item.answers.length < 1 && _vm.activity.type == 'Ordenar Letras' ||
      item.answers.length < 1 && _vm.activity.type == 'Parejas') ? _c('tbody', {
      staticClass: "mt-3"
    }, [(!_vm.isShow) ? _c('tr', [_vm._m(4, true), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.currentQuestionAnswer.text_answer),
        expression: "currentQuestionAnswer.text_answer"
      }],
      staticClass: "input w-full border mt-2 flex-1",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.currentQuestionAnswer.text_answer)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.currentQuestionAnswer, "text_answer", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button bg-theme-1 text-white mt-auto",
      attrs: {
        "type": "button",
        "disabled": !_vm.currentQuestionAnswer.text_answer
      },
      on: {
        "click": function($event) {
          return _vm.addAnswerToQuestion(questionIndex)
        }
      }
    }, [_vm._v("\n                            Agregar Respuesta\n                          ")])])]) : _vm._e()]) : _vm._e()])])])])]), _vm._v(" "), _vm._m(5, true)])
  }), _vm._v(" "), (!_vm.isShow) ? _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('button', {
    staticClass: "button bg-theme-1 text-white mt-auto w-auto",
    on: {
      "click": _vm.updateOrCreateQuestions
    }
  }, [_vm._v("\n                Guardar preguntas y respuestas\n              ")])])])]) : _vm._e()], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-4 flex"
  }, [_c('button', {
    staticClass: "button bg-theme-1 text-white mt-auto",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n            Agregar Pregunta\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "border-b dark:border-dark-5"
  }, [_c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("PREGUNTA")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("TIEMPO")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("ACCIONES")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("No hay Elementos seleccionados")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "border-b dark:border-dark-5"
  }, [_c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("Respuesta")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("Correcta")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("Acciones")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('label', [_vm._v("Agregar nueva respuesta:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ce3b6dd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/activity/ActivityQuestions.vue
// module id = 427
// module chunks = 1